// angular
import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
// services
import { StorageService } from '@shared/services/storage.service';
import { UserService } from '@shared/services/user.service';
// interfaces
import { ILoggedIn, ILogin } from '../interfaces/login.interface';
import {
  IResendOtp,
  ISignedIn,
  ISignup,
  ISignupSignal,
  IVerified,
} from '../interfaces/signup.interface';
import {environment} from "@environments/environment";
import {IForgotPass, IForgottenPass, IReqForgotPass, IResetPassSignal} from "@shared/interfaces/forgot.interface";

@Injectable()
export class AuthService {
  userSignUpState = signal<Partial<ISignupSignal>>({ state: 0 });
  userForgotPassState = signal<Partial<IResetPassSignal>>({ state: 0 });

  // dependencies
  private readonly _http = inject(HttpClient);
  private readonly _storageService = inject(StorageService);
  private readonly _userService = inject(UserService);

  public updateUserSignUpState(updatedField: Partial<ISignupSignal>) {
    this.userSignUpState.set({ ...this.userSignUpState(), ...updatedField });
  }

  public updateUserForgotPassState(updatedField: Partial<IResetPassSignal>) {
    this.userForgotPassState.set({ ...this.userForgotPassState(), ...updatedField });
  }

  public isLoggedIn() {
    const token = this._storageService.getToken(); // get token from local storage
    if (!token) return false;
    // if (!role) this._router.navigate(['/splash']); // go to role check page if do not selected role yet;
    const payload = atob(token.split('.')[1]); // decode payload of token
    const parsedPayload = JSON.parse(payload); // convert payload into an Object
    return parsedPayload.exp > Date.now() / 1000; // check if token is expired
  }

  public login(params: ILogin): Observable<ILoggedIn> {
    return this._http.post<ILoggedIn>('um/auth/login', params);
  }

  requestForgotPassword(params: IReqForgotPass){
    return this._http.post<{ hash: string }>('um/auth/request-forgot-password', params);
  }

  forgotPassword(params: IForgotPass){
    return this._http.post<IForgottenPass>('um/auth/forgot-password', params);
  }

  public refreshToken(redirectToPanel: boolean = false) {
    return this._http
      .post<{
        access_token: string;
      }>('um/auth/refresh', {
        refresh_token: this._storageService.getRefreshToken(),
      })
      .subscribe(res => {
        this._storageService.setToken(res.access_token);
        this._userService.createUserFromToken(res.access_token);
        if (redirectToPanel){
          setTimeout(() => {
            if (typeof window !== 'undefined') {
              window.location.href = environment.baseUrl.panelUrl;
            }
          }, 1500);
        }
      });
  }

  public signUp(params: ISignup) {
    return this._http.post<ISignedIn>('um/auth/register', { ...params });
  }

  public resendOtp(params: IResendOtp) {
    return this._http.post<{ success: boolean; hash: string }>('um/auth/resend-otp', params);
  }

  public verifyOtp(params: IVerified) {
    return this._http.post<{ success: boolean }>('um/auth/verify-otp', params);
  }
}
